import _ from 'lodash';
import request from 'superagent';
import * as types from '../actionTypes/creditorMailingTypes';


function mapResponseErrorsToMessage(err) {
  const request_id = _.get(err, ['response', 'body', 'error', 'request_id']);
  const errorMessageExtra = request_id
    ? `When contacting support, please quote Request ID '${request_id}'`
    : '';

  return {
    // We want to hide real messages from user since traces are confusing to them
    // TODO: coordinate with API to surface proper errors such as field validation?
    messages: [
      'PACER is experiencing some issues. Please try again in a few minutes.',
      errorMessageExtra,
    ],
    // but we include the real message in the details so we receive it in the sentry report
    details: _.get(err, ['response', 'body', 'error']) || [],
  };
}

function mapResponseToData(response, filters, searchType) {
  // todo check if other case menus return multiple types back like assoc cases
  let data = {};

  if (filters.type === 'associated_cases') {
    data = Array.isArray(response.body.queries)
      ? _.get(response.body, 'queries[0]', [])
      : _.get(response.body, 'queries', []);

    data = Object.keys(data).reduce((accum, next) => {
      accum.push([next, data[next][0].text]);
      return accum;
    }, []);
  } else if (filters.type === 'creditor_mailing') {
    data = Array.isArray(response.body.queries)
      ? _.get(response.body, 'queries[0].creditor_mailing[0]', [])
      : _.get(response.body, 'queries', []);
  } else if (filters.type === 'creditor_mailing_variant') {
    data = Array.isArray(response.body.queries)
      ? _.get(response.body, 'queries[0].creditor_mailing_variant[0]', [])
      : _.get(response.body, 'queries', []);
  } else {
    const type = searchType || filters.type;

    data = Array.isArray(response.body.queries)
      ? _.get(response.body, `queries[0].${type}[0].text`, [])
      : _.get(response.body, `queries.${type}[0].text`, []);
  }

  return data;
}

function receiveError(err) {
  const msg = mapResponseErrorsToMessage(err);
  return {
    type: types.SERVICE_ERROR,
    error: msg,
    errors: msg,
  };
}

function receiveCreditorMailingDataLocal(response, filters) {
  const data = mapResponseToData(response, filters);
  const { receipt } = filters;
  return {
    type: types.RECEIVE_CREDITOR_MAILING,
    data_type: filters.type,
    data,
    // data: _.get(response.body, `${filters.type}.text`, []),
    lastUpdated: _.get(response.body, `queries[0].${filters.type}[0].meta.timestamp`),
    receipt,
  };
}

function receiveCreditorMailingDataPurchased(response, filters) {
  const data = mapResponseToData(response, filters);

  return {
    type: types.RECEIVE_CREDITOR_MAILING,
    data_type: filters.type,
    data,
    // data: _.get(response.body, `${filters.type}.text`, []), // old
    lastUpdated: _.get(response.body, 'items.receipts[0].meta.timestamp'),
    receipt: _.get(response.body, 'items.receipts[0].text'),
  };
}

export const getCreditorMailingData = params => function (dispatch) {
  requestCreditorMailingData(params, dispatch);

  return request
    .post('/ir-search/query-json')
    .query({
      query: params.type,
      case_uuid: params.case_uuid,
    })
    .set('Accept', 'application/json')
    .then(
      (response) => {
        dispatch(receiveCreditorMailingDataLocal(response, params));
      },
      err => dispatch(receiveError(err)),
    );
};

export function requestCreditorMailingData(params, dispatch) {
  dispatch({
    type: types.REQUEST_CREDITOR_MAILING,
    params,
  });

  dispatch({
    type: types.RESET_SERVICE_ERROR,
  });
}

export const purchaseCreditorMailingData = params => function (dispatch) {
  requestCreditorMailingData(params, dispatch);

  return request
    .post('/ir-search/pacer-query-json')
    .query({
      query: params.type,
      case_uuid: params.case_uuid,
      format: params.format,
    })
    .set('Accept', 'application/json')
    .then(
      (response) => {
        window.refresh_menu(params.case_uuid);

        if (!_.isEmpty(response.body.error)) {
          return dispatch(receiveError(response));
        }
        params.receipt = _.get(response.body, 'items.receipts[0].text');
        params.type = params.queryType;
        return dispatch(getCreditorMailingData(params));
      },
      err => dispatch(receiveError(err)),
    );
};




// WEBPACK FOOTER //
// ./src/redux/actions/creditorMailingActions.js